<template>
  <div class="social-links">
    <div class="text-h6 font-weight-semibold mb-5 text-md-center">
      Contáctanos
    </div>
    <div class="level-center">
      <div class="text-md-center mb-4">
        <a :href="`mailto:${EMAIL_ADDRESS_HOLA}`">
          {{EMAIL_ADDRESS_HOLA}}
        </a>
      </div>
      <div class="level-item text-md-center">
        <v-btn
          dark
          fab
          small
          :href="`https://www.facebook.com/${BASE_DOMAIN}`"
          target="_blank"
          color="#fff"
          class="social-icon facebook mx-1"
          rel="noreferrer"
          alt="Eventeros - Facebook"
        >
          <v-icon>fa fa-facebook</v-icon>
        </v-btn>
        <v-btn
          dark
          fab
          small
          :href="`https://www.instagram.com/${BASE_DOMAIN}`"
          target="_blank"
          color="#fff"
          class="social-icon instagram mx-1"
          rel="noreferrer"
          alt="Eventeros - Instagram"
        >
          <v-icon>fa fa-instagram</v-icon>
        </v-btn>
        <v-btn
          dark
          fab
          small
          :href="`https://wa.me/${WHATSAPP_NUMBER}`"
          target="_blank"
          color="#fff"
          class="social-icon whatsapp mx-1"
          rel="noreferrer"
          alt="Eventeros - Whatsapp"
          v-if="false"
        >
          <v-icon>mdi-whatsapp</v-icon>
        </v-btn>
        <v-btn
          dark
          fab
          small
          :href="`https://m.me/${BASE_DOMAIN}`"
          target="_blank"
          color="#fff"
          class="social-icon messenger mx-1"
          rel="noreferrer"
          alt="Eventeros - Messenger"
        >
          <v-icon>mdi-facebook-messenger</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SocialLinks',
  data() {
    return {
      WHATSAPP_NUMBER: process.env.VUE_APP_WHATSAPP_NUMBER,
      BASE_DOMAIN: process.env.VUE_APP_BASE_DOMAIN,
      EMAIL_ADDRESS_HOLA: process.env.VUE_APP_EMAIL_ADDRESS_HOLA,
    };
  },
};
</script>

<style lang="scss" scoped>
.social-links {
  a {
    color:#fff!important;
  }

  .social-icon {
    color: #65416D!important;

    &:hover {
      color: #ffffff!important;
      &.facebook {
        background-color: #3b5998!important;
      }
      &.instagram {
        background-color: #dd2a7b!important;
      }
      &.whatsapp {
        background-color: #60bb39!important;
      }
      &.messenger {
        background-color: #0078FF!important;
      }
    }
  }
}
</style>
